<template>
	<div class="adminmember">
		<div class="member_content">
			<img class="img_default" :src="avatar?avatar:img.default">
			<!-- <div> -->
				<div class="member_name" @click="goLogin()">{{username}}</div>
				<!-- <div class="member_club">用户所属组织（或其他字段）</div> -->
				<!-- </div> -->
			</div>
			<div class="member_tit">主要功能</div>
			<div class="home_btnlistbox">
				<div class="home_btnlist">
					<!-- <div class="home_btn" @click="homeBtn(0)">首页</div> -->
					<div class="home_btn" @click="goPage('keywordnegative')">负面情绪关键词</div>
					<div class="home_btn margin-10" @click="goMessage()">预警消息
						<!-- <div class="message_tips">9</div> -->
					</div>
					<div class="home_btn_none"></div>
					<!-- <div class="home_btn" style="color: #9a9a9a;">舆情追踪</div> -->
				</div>
				<!-- <div class="home_btnlist">
					<div class="home_btn" style="color: #9a9a9a;">舆情走势</div>
					<div class="home_btn margin-10" style="color: #9a9a9a;">信息源头</div>
					<div class="home_btn" style="color: #9a9a9a;">传播路径</div>
				</div>
				<div class="home_btnlist">
					<div class="home_btn" style="color: #9a9a9a;">监控范围</div>
					<div class="home_btn margin-10" style="color: #9a9a9a;">舆情分析</div>
					<div class="home_btn" style="color: #9a9a9a;">正面情绪关键词</div>
				</div>
				<div class="home_btnlist">
					<div class="home_btn" style="color: #9a9a9a;">收藏</div>
					<div class="home_btn margin-10" style="color: #9a9a9a;">负面内容管理</div>
					<div class="home_btn" style="color: #9a9a9a;">正面内容管理</div>
				</div>
				<div class="home_btnlist">
					<div class="home_btn" style="color: #9a9a9a;">周报</div>
					<div class="home_btn margin-10" style="color: #9a9a9a;">月报</div>
					<div style="color: #9a9a9a;width: 33.333%"></div>
				</div> -->
			</div>
			<!-- <div class="exit" @click="exitAdmin()">退出登录</div> -->
		</div>
		
	</template>

	<script>
		import admin from '../../api/admin';
		import { mapState } from 'vuex';
		import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,Tab, Tabs,ActionSheet } from 'vant';
		export default {
			data () {
				return {
					avatar:'',
					username:'点击登录',
					img:{
						default:require('../../assets/img/default.jpg'),
					}
				}
			},
			computed: {
				...mapState({
					user: state => state.param.user
				})
			},
			
			created () {
				if(this.$route.query.token){
					this.token = this.$route.query.token
					this.$store.dispatch('param/setToken', this.$route.query.token)
					var memberinfo=JSON.parse(localStorage.getItem('user'))
					this.avatar=memberinfo.data.avatar
					this.username=memberinfo.data.username
				}
			},
			methods: {

				homeBtn(){
					wx.miniProgram.switchTab({url:'/pages/webpage/webpage?scene=adminkeyword'})
				},
				goPage(name){
					if(this.token){
						wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene='+name})
					}else{
						wx.miniProgram.navigateTo({url:'/pages/login/login'})
					}
				},
				goMessage(){
					if(this.token){
						wx.miniProgram.navigateTo({url:'/pages/messagelist/messagelist'})
					}else{
						wx.miniProgram.navigateTo({url:'/pages/login/login'})
					}
				},
				exitAdmin(){
					localStorage.clear();
					setTimeout(function(){
						wx.miniProgram.reLaunch({url:'/pages/exitlogin/exitlogin'})
					},200);
					
				},
				goLogin(){
					wx.miniProgram.navigateTo({url:'/pages/login/login'})
				}
			},
			components: {
				[Col.name]: Col,
				[Row.name]: Row,
				[Search.name]:Search,
				[Cell.name]:Cell,
				[Toast.name]:Toast,
				[DatetimePicker.name]:DatetimePicker,
				[Field.name]:Field,
				[Popup.name]:Popup,
				[Button.name]:Button,
				[Tab.name]:Tab,
				[Tabs.name]:Tabs,
				[Icon.name]:Icon,
				[ActionSheet.name]:ActionSheet
			}
		}
	</script>
	<style lang="scss">
	.adminmember{
		padding:15px;
		.member_content{
			display: flex;
			align-items:center;
			.img_default{
				width: 60px;
				height: 60px;
				border-radius:8px;
				margin: 10px 0;
				margin-right: 15px;
			}
			.member_name{
				color: #666666;
				font-size: 14px;
			}
		}
		.member_club{
			color: #999999;
			font-size: 12px;
			padding:10px 0;
		}
		.member_tit{
			color: #666666;
			font-size: 14px;
			padding:10px 0;
			margin-top: 10px;
			border-bottom:1px solid #EEEEEE;
		}
		.home_btnlistbox{
			padding:5px;

			.home_btnlist{
				display: flex;
				margin: 5px 0;
				.home_btn{
					width: 33.333%;
					font-size: 12px;
					color: #333333;
					border:1px solid #BBBBBB;
					padding:12px 0;
					text-align: center;
					border-radius: 4px;
					position:relative;

				}
				.home_btn_none{
					width: 33.333%;
					font-size: 12px;
					color: #333333;
					padding:12px 0;
					text-align: center;
					border-radius: 4px;
					position:relative;

				}
				.margin-10{
					margin: 0 10px;
				}
				.home_btn_active{
					background-color:#DDDDDD;
				}
			}
			.message_tips{
				position: absolute;
				top: -8px;
				right: -5px;
				background-color:#E02020;
				color: #fff;
				font-size: 6px;
				border-radius:4px;
				padding:2px 3px;
			}

		}
		.exit{
			color: #999999;
			font-size: 12px;
			text-align: center;
			margin-top: 70px;
			text-decoration: underline;
		}
	}

</style>